import { render, staticRenderFns } from "./pay-pattern.vue?vue&type=template&id=6e2748cc&scoped=true"
import script from "./pay-pattern.vue?vue&type=script&lang=js"
export * from "./pay-pattern.vue?vue&type=script&lang=js"
import style0 from "./pay-pattern.vue?vue&type=style&index=0&id=6e2748cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2748cc",
  null
  
)

export default component.exports